import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import * as icons from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, Row, Col, Button, Form } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { Creators as resetPasswordActions } from '../../appRedux/ducks/auth/resetPassword'
import logo from '../../assets/images/Logo@2x.png'
import CustomInput from '../../components/CustomInput/customInput'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
// Import { Creators as passwordRecoveryActions } from '../../appRedux/ducks/auth/passwordRecovery'
import { validatePassword } from '../../util/passwordValidation'
import PasswordPopover from '../Login/PasswordPopover'
import './styles.css'

const PasswordRecovery = function ({ history }) {
  const params = new URLSearchParams(history.location.search)
  const token = params.get('token') || null
  const [step, setStep] = useState(!token ? 'email' : 'formVerification')
  // eslint-disable-next-line no-unused-vars
  const [selectedEmail, setSelectedEmail] = useState('')
  const dispatch = useDispatch()
  const resetPassword = useSelector((state) => state.resetPassword)
  const passwordRecovery = useSelector((state) => state.passwordRecovery)
  useEffect(() => {
    return () => {
      setStep('email')
    }
  }, [])

  useEffect(() => {
    if (passwordRecovery.status === 'success') {
      setStep('formVerification')
    }
  }, [passwordRecovery.status])

  useEffect(() => {
    if (resetPassword.status === 'success') {
      history.push('/login')
      dispatch(resetPasswordActions.reset())
    }
  }, [resetPassword.status])

  const form = {
    initialValues: {},
    yupValidation: yup.object().shape({
      email: yup
        .string()
        .min(1, getMessage('minLenght', 'E-mail', '4'))
        .email(getMessage('isInvalidEmail'))
        .required(getMessage('isRequired', 'E-mail'))
    }),
    onSubmit: async (values) => {
      setSelectedEmail(values.email)
      await request(api.passwordRecovery({ userLogin: values.email }))
      setStep('sentVerificationCode')
    }
  }

  const formVerification = {
    initialValues: {},
    yupValidation: yup.object().shape({
      typeNewPassword: yup
        .string()
        .min(6, getMessage('minLenght', 'Senha', '6'))
        .required(getMessage('isRequired', 'Senha'))
        .test('password', getMessage('passwordValidationFailed'), (value) => validatePassword(value))
    }),
    onSubmit: async (values) => {
      console.tron.log('formVerification', values)
      await request(api.passwordReset({ token, password: values.typeNewPassword }))
      setStep('passwordModified')
    }
  }
  return (
    <div className="mainlyContainer">
      <Row className="row">
        <Col xs={6} sm={1} md={3} lg={3} xl={4} />
        <Col xs={6} sm={1} md={2} lg={3} xl={4} />
        <Col xs={24} sm={20} md={14} lg={12} xl={8}>
          {step === 'email' && (
            <Card className="containerLogin">
              <img src={logo} alt="Soyshare Logo" className="logo" />
              <div className="containerForm">
                <label className="title" style={{ textAlign: 'left' }}>
                  {getMessage('app.userAuth.forgotPassword')}
                </label>
                <Formik
                  enableReinitialize
                  validationSchema={form.yupValidation}
                  initialValues={form.initialValues}
                  onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
                    form.onSubmit(values, setSubmitting, setFieldError, resetForm)
                  }
                  validateOnChange={false}
                  validateOnBlur={false}
                >
                  {({
                    values,
                    errors,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    submitForm
                    /* And other goodies */
                  }) => {
                    return (
                      <Form className="login-form" layout="vertical" onSubmit={handleSubmit}>
                        <br />
                        <Row type="flex" justify="start">
                          <CustomInput
                            prefix={<FontAwesomeIcon icon={icons.faUser} size="sm" style={{ marginRight: 10 }} />}
                            customNameField="emptyString"
                            placeholder="E-mail"
                            field="email"
                            errors={errors}
                            setFieldValue={setFieldValue}
                            rowSpan={24}
                            value={values}
                            handleBlur={handleBlur}
                            className="InputText"
                          />
                        </Row>
                        <div className="paddingBtn containerFormActions">
                          <div />
                          <Button className="btEnter" type="dashed" onClick={() => submitForm()}>
                            Enviar solicitação
                          </Button>
                          <Button
                            type="link"
                            // className="btEnter"
                            onClick={() => {
                              console.tron.log('history', history)
                              history.push('/login')
                            }}
                          >
                            <span className="textColorWhite">Voltar para login</span>
                          </Button>
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </div>
            </Card>
          )}
          {step === 'formVerification' && (
            <Card className="containerLogin">
              <img src={logo} alt="Soyshare Logo" className="logo" />
              <label>Esqueci minha senha</label>
              <div className="containerForm">
                <Formik
                  enableReinitialize
                  validationSchema={formVerification.yupValidation}
                  initialValues={formVerification.initialValues}
                  onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
                    formVerification.onSubmit(values, setSubmitting, setFieldError, resetForm)
                  }
                  validateOnChange={false}
                  validateOnBlur={false}
                >
                  {({
                    values,
                    errors,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    submitForm
                    /* And other goodies */
                  }) => {
                    return (
                      <Form className="login-form" layout="vertical" onSubmit={handleSubmit}>
                        <Row type="flex" justify="start">
                          <CustomInput
                            information={PasswordPopover}
                            title="Critérios de Senha"
                            icon="info-circle"
                            type="password"
                            prefix={<FontAwesomeIcon icon={icons.faKey} size="sm" style={{ marginRight: 10 }} />}
                            field="typeNewPassword"
                            errors={errors}
                            setFieldValue={setFieldValue}
                            rowSpan={24}
                            value={values}
                            handleBlur={handleBlur}
                          />
                        </Row>
                        <div className="containerFormActions">
                          <div />
                          <Button className="bgPrimary" type="primary" onClick={() => submitForm()}>
                            Cadastrar
                          </Button>
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </div>
            </Card>
          )}
          {step === 'sentVerificationCode' && (
            <Card className="containerLogin">
              <img src={logo} alt="Soyshare Logo" className="logo" />
              <label className="title">Esqueci minha senha</label>
              <p className="description">
                Enviamos um link para resetar sua senha, verifique seu e-mail. Se o e-mail não chegar em alguns minutos,
                verifique a caixa de spam.
              </p>
              <Button className="bgPrimary" type="primary" onClick={() => history.push('/login')}>
                Página Inicial
              </Button>
            </Card>
          )}
          {step === 'passwordModified' && (
            <Card className="containerLogin">
              <img src={logo} alt="Soyshare Logo" className="logo" />
              <label className="title">Esqueci minha senha</label>
              <p className="description">Senha modificada com sucesso.</p>
              <Button className="bgPrimary" type="primary" onClick={() => history.push('/login')}>
                Página Inicial
              </Button>
            </Card>
          )}
        </Col>
        <Col xs={6} sm={1} md={2} lg={3} xl={4} />
        <Col xs={6} sm={1} md={3} lg={3} xl={4} />
      </Row>
    </div>
  )
}

export default PasswordRecovery
